import { render, staticRenderFns } from "./hrd-add-trainer.vue?vue&type=template&id=1b26e650&scoped=true"
import script from "./hrd-add-trainer.vue?vue&type=script&lang=js"
export * from "./hrd-add-trainer.vue?vue&type=script&lang=js"
import style0 from "./hrd-add-trainer.vue?vue&type=style&index=0&id=1b26e650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b26e650",
  null
  
)

export default component.exports